
<div class="container" style="min-height: 400px">
  <div class="section-header">
    <h2>404 page not found</h2>
  </div>
  <img src="assets/img/logo/mineInsiders.jpeg" class="img-responsive" alt="" title="" />
</div>

